<template>
  <el-dialog title="群管理员设置" :visible.sync="visible" width="560px" append-to-body>
    <el-alert type="info" :closable="false" title="群管理员可维护群资料、成员和群聊权限；只有群主可以添加或移除管理员。" />
    <div class="add-row">
      <el-select v-model="candidateId" filterable clearable placeholder="选择要设为管理员的成员" class="candidate-select">
        <el-option v-for="member in candidates" :key="member.userId" :label="member.showNickName" :value="member.userId" />
      </el-select>
      <el-button type="primary" :disabled="!candidateId" :loading="saving" @click="addManager">添加管理员</el-button>
    </div>
    <el-table :data="managers" empty-text="暂未设置群管理员">
      <el-table-column label="管理员">
        <template slot-scope="scope">
          <div class="member-cell"><head-image :size="34" :url="scope.row.headImage" :name="scope.row.showNickName"/><span>{{ scope.row.showNickName }}</span></div>
        </template>
      </el-table-column>
      <el-table-column prop="userName" label="账号" />
      <el-table-column label="操作" width="90">
        <template slot-scope="scope"><el-button type="text" class="danger" @click="removeManager(scope.row)">移除</el-button></template>
      </el-table-column>
    </el-table>
    <span slot="footer"><el-button @click="visible=false">关闭</el-button></span>
  </el-dialog>
</template>

<script>
import HeadImage from '../common/HeadImage.vue';

export default {
  name: 'GroupManagerDialog',
  components: { HeadImage },
  props: {
    group: { type: Object, required: true },
    groupMembers: { type: Array, default: () => [] }
  },
  data() {
    return { visible: false, candidateId: null, saving: false }
  },
  computed: {
    managers() {
      return this.groupMembers.filter(member => !member.quit && member.isManager)
    },
    candidates() {
      return this.groupMembers.filter(member => !member.quit && !member.isManager && member.userId != this.group.ownerId)
    }
  },
  methods: {
    open() {
      this.candidateId = null
      this.visible = true
    },
    addManager() {
      const member = this.groupMembers.find(item => item.userId == this.candidateId)
      if (!member) return
      this.saving = true
      this.$http({ url: '/group/manager/add', method: 'post', data: { groupId: this.group.id, userIds: [member.userId] } })
        .then(() => {
          member.isManager = true
          this.candidateId = null
          this.$message.success(`已将 ${member.showNickName} 设为群管理员`)
        }).finally(() => this.saving = false)
    },
    removeManager(member) {
      this.$confirm(`确认取消 ${member.showNickName} 的群管理员权限？`, '提示', { type: 'warning' }).then(() =>
        this.$http({ url: '/group/manager/remove', method: 'delete', data: { groupId: this.group.id, userIds: [member.userId] } })
      ).then(() => {
        member.isManager = false
        this.$message.success('已取消群管理员')
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.add-row{display:flex;gap:12px;margin:16px 0}.candidate-select{flex:1}.member-cell{display:flex;align-items:center;gap:10px}.danger{color:#f56c6c}
</style>
